import { makeOrderResponseMessages } from '../../constants/makeOrderResponse';

export const shouldRedirectToStartPage = (messageId: string) =>
  [makeOrderResponseMessages.PRECONDITIONS_VALIDATION_FAILED].some(
    (errorMessage) => errorMessage === messageId,
  );

export const shouldRedirectToResultPage = (messageId: string) =>
  [makeOrderResponseMessages.CART_RESTART_FROM_SEARCH].some(
    (errorMessage) => errorMessage === messageId,
  );
